import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import ServiceSection from "./ServiceSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import BlogSlider from "../../components/BlogList/BlogTopList";

const ServicePage: React.FC = () => {
  useEffect(() => {
      document.title = "Services | Brain Machine AI";
    }, []);
  return (
    <Fragment>
      <div className='about-page inner-page'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Services" pagesub="Services" />
            <BlogSlider></BlogSlider>
            <ServiceSection />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ServicePage;
